import Analytics from '../helpers/analytics';
import Utilities from '../helpers/utilities';
import 'jquery-mask-plugin';

import applyprogress from './applyprogress';

export default class {

    constructor() {
        this.firstLoad = true;
        this.analytics = new Analytics();
        this.utilities = new Utilities();

        if (this.utilities.smartLoad('.registration-form-2018')) {
            this.hasAttemptedSubmit = false;
            this.registrationForm = $('.registration-form-2018');
            this.serviceCheckButton = $('.service-toggle');
            this.currentServiceCheckButton = $('.currently-toggle-2017');            
            this.registrationFormEvents();
            this.genderSelfDescribe();      
            this.dateComponentEntry();
            this.nextButtonClickEvent();
            this.onSubmit();

            $('.registration-form-2018').on('keyup change blur', 'input, select, textarea, .dobcomponent', (e) => {
                this.updateSubmitValidationMessage();
            });
        }
    }

    dateComponentEntry() {        
        var self = this;
        $('.dobcomponent').on('focusout', function() {
            self.buildDob();
        });

        // User cannot see this box but we use it programatically
        // Prevent tabbing to and changing values by accident
        $('.gtm-apply-date-of-birth').on('keydown', function(e) {
            e.preventDefault();
            return false;
         });
    }
        
    buildDob() {
        // 1. Combine values into hidden field
        const day = $('#dobDay').val().trim();
        const month = $('#dobMonth').val().trim();
        const year = $('#dobYear').val().trim();
        
        const dobHiddenInput = $('.gtm-apply-date-of-birth');
        
        if (day && month && year) {
            dobHiddenInput.val(`${day}-${month}-${year}`);
        } else {
            dobHiddenInput.val('');
        }

        var dobEmptyValidationField = $('span[data-valmsg-for="Dob"]');
        var dobValidationField = $('span[data-valmsg-for="DateValidation"]');

        // Reset DateValidation message
        dobValidationField.removeClass('field-validation-error').addClass('field-validation-valid').text('');

        // Check empty state
        if (!day || !month || !year) {
            dobEmptyValidationField
                .removeClass('field-validation-valid')
                .addClass('field-validation-error')
                .html('<span id="Dob-error">Please enter your date of birth</span>');
            return false; // Has error
        } else {
            dobEmptyValidationField
                .removeClass('field-validation-error')
                .addClass('field-validation-valid')
                .text('');
        }

        // Check date validity & age requirements
        var enteredDobString = `${year}-${month}-${day}`;
        if (isNaN(Date.parse(enteredDobString)) || isNaN(year) || isNaN(month) || isNaN(day)) {
            dobValidationField
                .removeClass('field-validation-valid')
                .addClass('field-validation-error')
                .html('<span id="DateValidation-error">Entered date is not valid</span>');
            return false; // Has error
        } else {
            var enteredDob = new Date(enteredDobString);
            var minAgeDob = new Date();
            minAgeDob.setMonth(new Date().getMonth() - $('#AgeValues').data('minage') * 12);                
            var daysDifference = (minAgeDob - enteredDob) / (1000 * 3600 * 24);

            if (daysDifference <= -92) {
                dobValidationField
                    .removeClass('field-validation-valid')
                    .addClass('field-validation-error');

                if (daysDifference > -365) {                        
                    dobValidationField.html('<span id="DateValidation-error">' + $('#AgeValues').data('softmessage') + '</span>');
                } else {
                    dobValidationField.html('<span id="DateValidation-error">' + $('#AgeValues').data('hardmessage') + '</span>');
                }
                return false; // Has error
            }
        }

        return true; // No DOB error
    }

    registrationFormEvents() {
        this.eligibilityCheck();        
        this.serviceCheck();
    }

    genderSelfDescribe() {

        // trigger events
        $("#GenderSelfDescribeArea").hide();
        $("#GenderSelfDescValidation").hide();

        $("#Gender").on('change', function() {            
            if (this.value == "PreferToSelfDescribe") {
                $("#GenderSelfDescribeArea").show();
            }
            else {
                $("#GenderSelfDescribeArea").find("input[type=text]").val("");
                $("#GenderSelfDescribeArea").hide();
                $("#GenderSelfDescValidation").hide();
            }
        });

        $("#genderSelfDesc").on('change', function() {
            if ($("#genderSelfDesc")[0].value == '') {
                $("#genderSelfDescValidation").show();
            }
            else
            {
                $("#genderSelfDescValidation").hide();                
            }
        });

        // page load
        if ($("#Gender")[0].value == "PreferToSelfDescribe") {
            $("#GenderSelfDescribeArea").show();

            if ($("#GenderSelfDesc")[0].value == '') {
                $("#GenderSelfDescValidation").show();
            }
        }        
    }
 
    eligibilityCheck() {
        $('.alert-panel').hide();
        $('.content[data-eligibilitystep="1"').show();
        $('.content[data-eligibilitystep="2"').hide();
        $('.content[data-eligibilitystep="3"').hide();
        this.eligibilityCheck1();
        this.eligibilityCheck2();
        this.eligibilityCheck3();
    }

    eligibilityCheck1() {

        $('input[name="eligibleAge"]').on('change', function() {
            var selection = $('input[name="eligibleAge"]:checked');
            if (selection.val() == 'yes') {       
                $('.eligibility-age-stepbutton').text('Next');
                selection.closest('.content').find('.alert-panel').hide();
            }            
            if (selection.val() == 'no') {
                $('.eligibility-age-stepbutton').text('Contact us');
                selection.closest('.content').find('.alert-panel').show();
            }
            $('.eligibility-age-stepbutton').prop('disabled', false);
        });

        $('.eligibility-age-stepbutton').on('click', (e) => {
            e.preventDefault();
            var selection = $('input[name="eligibleAge"]:checked');
            if (selection.val() == 'yes') {
                $('.content[data-eligibilitystep="1"').hide();
                $('.content[data-eligibilitystep="2"').show();
                this.panelScroll();
            }            
            if (selection.val() == 'no') {
                window.location.href = "/contact";
            }
        });
    }

    eligibilityCheck2() {

        $('input[name="eligibleNationality"]').on('change', function() {
            var selection = $('input[name="eligibleNationality"]:checked');
            if (selection.val() == 'yes') {       
                $('.eligibility-nationality-stepbutton').text('Next');
                selection.closest('.content').find('.alert-panel').hide();
            }            
            if (selection.val() == 'no') {
                $('.eligibility-nationality-stepbutton').text('Contact us');
                selection.closest('.content').find('.alert-panel').show();
            }
            $('.eligibility-nationality-stepbutton').prop('disabled', false);
        });

        $('.eligibility-nationality-stepbutton').on('click', (e) => {
            e.preventDefault();
            var selection = $('input[name="eligibleNationality"]:checked');
            if (selection.val() == 'yes') {
                $('.content[data-eligibilitystep="2"').hide();
                $('.content[data-eligibilitystep="3"').show();                
                this.panelScroll();
            }            
            if (selection.val() == 'no') {
                window.location.href = "/contact";
            }
        });

    }

    eligibilityCheck3() {
        
        $('input[name="eligibleQualifications"]').on('change', function() {
            var selection = $('input[name="eligibleQualifications"]:checked');
            if (selection.val() == 'yes') {       
                $('.eligibility-qualifications-stepbutton').text('Next');
                selection.closest('.content').find('.alert-panel').hide();
            }            
            if (selection.val() == 'no') {
                $('.eligibility-qualifications-stepbutton').text('Contact us');
                selection.closest('.content').find('.alert-panel').show();
            }
            $('.eligibility-qualifications-stepbutton').prop('disabled', false);
        });

        $('.eligibility-qualifications-stepbutton').on('click', (e) => {
            e.preventDefault();
            var selection = $('input[name="eligibleQualifications"]:checked');
            if (selection.val() == 'yes') {

                // Reserves only do eligilibility checks before going to external site
                const params = new URLSearchParams(window.location.search);
                if (params.get('type') === 'reserve') {
                    let queryParts = [];
                    for (const [key, value] of params.entries()) {
                        if (/^r\d+$/.test(key) && value) {
                            const roleIndex = key.substring(1);
                            queryParts.push(`role${roleIndex}=${encodeURIComponent(value)}`);
                        }
                    }
                    const query = queryParts.join('&') + '&type=reserve';
                    window.location.href = `/apply/thank-you-reserve?${query}`;
                }
                else {
                    $('.content[data-eligibilitystep="3"').hide();
                    $('.step-1').hide();
                    $('#register-2017-step-2').show();
                    this.panelScroll();

                    // Update the progress bar (different module)...
                    var progress = new applyprogress();
                    progress.currentStage = 3;
                    progress.setStage();
                }                
            }            
            if (selection.val() == 'no') {
                window.location.href = "/contact";
            }
        });

    }

    serviceCheck() {

        var self = this;

        $('input[name="serving"]').on('change', (e) => {
            
            e.preventDefault();
            
            const $el = $(e.currentTarget);
            const $rejoiners = $('.rejoiners-serving-container');
            const $currentlyServing = $('.currently-serving-container');
            const $nextButton = $('#nextButton');      
            
            $nextButton.prop('disabled', true);

            //this.serviceCheckButton.removeClass('active');
            //$el.addClass('active');
            $('label[for^="serving_"]').removeClass('active');
            $('label[for="' + $el.attr('id') + '"]').addClass('active');
           
            switch($el.val()) {
                case "Currently":
                    $rejoiners.hide();
                    $currentlyServing.show();
                    $nextButton.text('Next');
                    self.currentlyServingButtonState();
                    break;
                case "Previously":
                    $currentlyServing.hide();       
                    $rejoiners.show();       
                    $nextButton.text('Rejoiners');             
                    $nextButton.prop('disabled', false);
                    break;
                case "Never":
                    $currentlyServing.hide();                    
                    $rejoiners.hide();
                    $nextButton.text('Next');
                    $nextButton.prop('disabled', false);
                    break;                
            }
                        
            self.analytics.track('Register Your Interest', 'Serving in Armed Forces', $el.val(), $el.val());
        });

        $('#Service').on('change', (e) => {
            self.currentlyServingButtonState();
        });

        $('#auth-confirm').on('change', (e) => {
            self.currentlyServingButtonState();
        });
    }

    currentlyServingButtonState() {
        if ($('#auth-confirm').prop('checked') && $('#Service').val() != "0") {
            $('#nextButton').prop('disabled', false);
        } else {
            $('#nextButton').prop('disabled', true);
        }
    }

    nextButtonClickEvent() {
        $('#nextButton').on('click', function(e) {
            e.preventDefault();
            if ($('#serving_previously').hasClass('.active')) {
                window.location.href = '/contact';
            } else {
                $('#register-2017-step-2').hide();
                $('#register-2017-step-3').show();
            }
        });
    }

    updateSubmitValidationMessage() {
        if (!this.hasAttemptedSubmit)
            return;

        const isDobValid = this.buildDob();
        const hasMvcErrors = !this.registrationForm.valid();
        const hasGenderError = $('#Gender').val() === 'PreferToSelfDescribe' && $('#GenderSelfDesc').val() === '';

        if (hasGenderError || !isDobValid || hasMvcErrors) {
            $('#SubmitValidationMessage').show();
        } else {
            $('#SubmitValidationMessage').hide();
        }
    }

    onSubmit() {
        $('.registration-form-2017-send').on('click', (e) => {

            this.hasAttemptedSubmit = true;
            
            this.updateSubmitValidationMessage();

            if ($('#SubmitValidationMessage').is(':visible')) {
                return false;
            }

            $('.registration-form-2017-send').hide();
            $('.registration-form-2017-send-loading').addClass('show');
        });        
    }    

    panelScroll() {
        const $header = $('.header-wrapper');
        const offset = $header.length ? $header.outerHeight() : 0;        
        const targetTop = $('.register-your-interest')[0].getBoundingClientRect().top + window.pageYOffset;
        const top = targetTop - offset - 20;
        $(window).scrollTop(top);
    }
}
